<template>
  <div>
    <sweet-modal ref="sliderAddImage" width="50vw" :title="$t('ct-component-SliderGalleryComponent')">
      <div class="slider-modal-images">
        <draggable class="slider-area-images" handle=".action-move-img" v-model="internal_config.images">
          <div
            class="slider-box-image"
            v-for="(image, index) in internal_config.images"
            :key="index"
          >
            <div :style="{ backgroundImage: `url('${image}')` }" class="slider-box-image"/>
            <div class="slider-box-option">
              <span class="action-move-img"><font-awesome-icon :icon="['fas', 'arrows-alt']" color="#fff"/></span>
              <span v-if="internal_config.images.length > 1" @click.prevent="deleteImage(index)">
                <font-awesome-icon :icon="['far', 'trash-alt']" color="#fff"/>
              </span>
            </div>
          </div>
        </draggable>
      </div>
      <button slot="button" class="btn btn-primary float-left ml-0" @click="getImages"><i class="svg-icon svgi-add-page"></i>{{$t('ct-add-imagem')}}</button>
      <button slot="button" class="btn btn-outline-light" @click="cancel">{{ $t('ct-cancel') }}</button>
      <button slot="button" class="btn btn-success" @click="$refs.sliderAddImage.close()"><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}</button>
    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import Draggable from 'vuedraggable';

export default {
  name: 'SliderGalleryConfigModals',
  components: {
    SweetModal,
    Draggable
  },
  data() {
    return {
      internal_config: false,
      internal_config_current: false,
      callback: false
    };
  },
  methods: {
    init(config, callback = false) {
      this.internal_config = config;
      this.internal_config_current = {...this.internal_config};
      this.callback = callback;
    },
    open(modal) {
      if (this.$refs[modal]) { this.$refs[modal].open() }
    },
    cancel() {
      this.callback(this.internal_config_current);
      this.$refs.sliderAddImage.close();
    },
    getImages() {
      document.getElementsByClassName(
        'panel-components-right'
      )[0].style.zIndex = 0;

      let values = {
        action: 'open',
        type: 'Images',
        multiple: true,
        save: this.saveFile,
        close: this.closeFile,
        maxSelectedFiles: 10
      };
      this.$root.$emit('fileMananger', values);
    },
    async saveFile(images) {
      this.$loading.show();

      document.getElementsByClassName('panel-components-right')[0].removeAttribute('style');

      let normalizedImages = [];

      if (Array.isArray(images)) {
        normalizedImages = images;
      } else if (typeof images === 'string') {
        normalizedImages = images
          .split(',')
          .map(img => img.trim())
          .filter(Boolean);
      }

      this.internal_config.images.push(...normalizedImages);

      this.$root.$emit('fileMananger', {
        action: 'close',
        type: 'Files',
        save: this.saveFile,
        close: this.closeFile
      });

      this.$loading.hide();
    },
    deleteImage(index) {
      this.internal_config.images.splice(index, 1);
    },
    closeFile() {
      document
        .getElementsByClassName('panel-components-right')[0]
        .removeAttribute('style');

      let values = {
        action: 'close',
        type: 'Files',
        save: this.saveFile,
        close: this.closeFile
      };
      this.$root.$emit('fileMananger', values);
    }
  }
};
</script>
<style scoped lang="scss">
  .slider-modal-images {
    display: flex;
    flex-direction: column;

    :nth-child(4) {
      text-align: right;
    }
  }

  .slider-area-images {
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-row-gap: 10px;
    grid-column-gap: 10px;
    margin: 20px 0 20px 0;
  }
  .slider-box-image {
    position: relative;
    background-color: rgba(29, 64, 89, 0.8);
    border-radius: 10px;

    .slider-box-image {
      width: 100%;
      height: 150px;
      opacity: 1;
      display: block;
      transition: 0.5s ease;
      backface-visibility: hidden;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }

    &:hover .slider-box-image {
      opacity: 0.3;
    }

    .slider-box-option {
      transition: 0.5s ease;
      opacity: 0;
      position: absolute;
      width: 100px;
      height: 34px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      text-align: center;

      span {
        width: 34px;
        height: 34px;
        border-radius: 100%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
          background-color: gray;
        }
      }
    }

    &:hover .slider-box-option {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/SliderGallery/ConfigModals.vue